import React, { useState, useEffect } from 'react';
import './CSS/Dashboard.css';

// Admin panel for the Redsys/Getnet TPV configuration.
// Non-secret settings are stored in the DB (per environment). The signature key
// is managed securely in env/SSM and is never shown or edited here.
const ManagePaymentSettings = ({ backendUrl, resetKey }) => {
  const [settings, setSettings] = useState({
    enabled: false,
    merchantCode: '',
    terminal: '',
    currency: '978',
    environment: 'test',
    merchantUrl: '',
    urlOk: '',
    urlKo: '',
  });
  const [secretKeyConfigured, setSecretKeyConfigured] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey]);

  const fetchSettings = async () => {
    const token = localStorage.getItem('auth-token');
    try {
      const response = await fetch(`${backendUrl}/payment-settings`, {
        headers: { 'Content-Type': 'application/json', 'auth-token': token },
      });
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings({
          enabled: data.settings.enabled === true,
          merchantCode: data.settings.merchantCode || '',
          terminal: data.settings.terminal || '',
          currency: data.settings.currency || '978',
          environment: data.settings.environment || 'test',
          merchantUrl: data.settings.merchantUrl || '',
          urlOk: data.settings.urlOk || '',
          urlKo: data.settings.urlKo || '',
        });
        setSecretKeyConfigured(!!data.secretKeyConfigured);
      }
    } catch (err) {
      console.error('Error fetching payment settings:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const saveSettings = async () => {
    const token = localStorage.getItem('auth-token');
    try {
      const response = await fetch(`${backendUrl}/payment-settings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'auth-token': token },
        body: JSON.stringify(settings),
      });
      const data = await response.json();
      if (data.success) {
        alert('Payment settings saved successfully!');
      } else {
        alert('Error saving settings: ' + data.message);
      }
    } catch (err) {
      console.error('Error saving payment settings:', err);
      alert('Error saving settings');
    }
  };

  if (loading) return <div>Loading settings...</div>;

  return (
    <div className="form-group" style={{ maxWidth: '600px' }}>
      <h2>Manage Payment Settings (Redsys / Getnet)</h2>

      <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <input type="checkbox" name="enabled" checked={settings.enabled} onChange={handleChange} style={{ width: 'auto' }} />
        Card payments enabled
      </label>

      <label>Environment</label>
      <select name="environment" value={settings.environment} onChange={handleChange}>
        <option value="test">Test (sandbox)</option>
        <option value="live">Live (production)</option>
      </select>

      <label>Merchant code (FUC)</label>
      <input type="text" name="merchantCode" value={settings.merchantCode} onChange={handleChange} placeholder="048151971" />

      <label>Terminal</label>
      <input type="text" name="terminal" value={settings.terminal} onChange={handleChange} placeholder="001" />

      <label>Currency (ISO-4217 numeric)</label>
      <input type="text" name="currency" value={settings.currency} onChange={handleChange} placeholder="978" />

      <label>Notification URL (webhook)</label>
      <input type="text" name="merchantUrl" value={settings.merchantUrl} onChange={handleChange} placeholder="https://api.example.com/payment/redsys/notification" />

      <label>Return URL — success</label>
      <input type="text" name="urlOk" value={settings.urlOk} onChange={handleChange} placeholder="https://example.com/payment-success" />

      <label>Return URL — failure</label>
      <input type="text" name="urlKo" value={settings.urlKo} onChange={handleChange} placeholder="https://example.com/payment-error" />

      <p style={{ marginTop: '16px', fontSize: '13px', color: secretKeyConfigured ? '#48bb78' : '#f56565' }}>
        Signature key: {secretKeyConfigured
          ? '•••• configured (managed securely in SSM / env)'
          : 'NOT configured — set REDSYS_SECRET_KEY in SSM / env'}
      </p>

      <button onClick={saveSettings} style={{ marginTop: '20px' }}>Save Settings</button>
    </div>
  );
};

export default ManagePaymentSettings;
